/**
 * Benefits JS
 * -----------------------------------------------------------------------------
 *
 * All the JS for the Benefits component.
 */

import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    className: 'benefits',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      $( '.benefits' ).each( function( key, component ) {
        const mainEl = component.querySelector( '.benefits__main-splide' );
        const secondaryEl = component.querySelector( '.benefits__splide' );

        const mainSlider = new Splide( mainEl, {
          type: 'slide',
          perPage: 1,
          pagination: false,
          focus: 'center',
          drag: false,
          arrows: true,
          gap: '120px',
          speed: 800,
          autoWidth: false,
          // direction: 'ltr',
        } );

        if ( secondaryEl ) {
          const fadeSlider = new Splide( secondaryEl, {
            type: 'fade',
            perPage: 1,
            speed: 800,
            pagination: false,
            focus: 'center',
            drag: false,
            arrows: false,
            autoWidth: false,
            direction: 'ltr',
          } );

          mainSlider.sync( fadeSlider );
          fadeSlider.mount();
        }

        mainSlider.mount();
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'benefits', COMPONENT );
} )( app );
